import { ref } from 'vue';
/**
 * Tracks which EnSelectField instance is currently open.
 *
 * Each EnSelectField generates a unique Symbol (selfId) on creation. When it
 * opens, it writes that symbol here.
 *
 * This ref intentionally lives at module scope (outside component),
 * so it is created exactly once and shared across every EnSelectField on the
 * page.
 */
export const openSelectId = ref(null);
